module.exports = __webpack_public_path__ + "img/altitude-resort-3.e1ce5d89.jpg";